import { DtoExt } from '@/classes/scenario/DtoExt';
import { ScenarioCapex } from '@/dto/scenario/ren-fr/capex/ScenarioCapex';
import { localeDateFromUTC, localeDateToUTC } from '@/helpers/timeHelper';

export class ScenarioCapexExt extends DtoExt {

  public spvPurchaseDate: string | null = '';
  public spvPurchase: number | null = null;
  public impactStudy: number | null = null;
  public publicInquiry: number | null = null;
  public permitDisplay: number | null = null;
  public technical: number | null = null;
  public businessDeveloper: number | null = null;
  public archaeologicalAssessment: number | null = null;
  public lawyerFees: number | null = null;
  public assetRent: number | null = null;
  public devContractRenFr: number | null = null;
  public devContractExternal: number | null = null;
  public amoContract: number | null = null;
  public others: number | null = null;
  public productible: number | null = null;
  public authorizations: number | null = null;
  public gridConnection: string | null = '';
  public specializedLink: boolean | null = null;
  public gridConnectionCost: number | null = null;
  public regionShare: number | null = null;
  public telecom: number | null = null;
  public environmentalMonitoring: number | null = null;
  public ercMeasures: number | null = null;
  public lot0_CspsCt: number | null = null;
  public lot1_PublicWorks: number | null = null;
  public lot2_Foundations: number | null = null;
  public lot3_ElectricalNetwork: number | null = null;
  public lot4_PdlPtr: number | null = null;
  public lot5_WindTurbines: number | null = null;
  public lot6_Supervision: number | null = null;
  public lot7_Ess: number | null = null;
  public lot8_Modules: number | null = null;
  public lot9_Decommissioning: number | null = null;
  public lot10_Transport: number | null = null;
  public misc: number | null = null;
  public uncertainties: number | null = null;

  private static fieldList = [
    'spvPurchaseDate',
    'spvPurchase',
    'impactStudy',
    'publicInquiry',
    'permitDisplay',
    'technical',
    'businessDeveloper',
    'archaeologicalAssessment',
    'lawyerFees',
    'assetRent',
    'devContractRenFr',
    'devContractExternal',
    'amoContract',
    'others',
    'productible',
    'authorizations',
    'gridConnection',
    'specializedLink',
    'gridConnectionCost',
    'regionShare',
    'telecom',
    'environmentalMonitoring',
    'ercMeasures',
    'lot0_CspsCt',
    'lot1_PublicWorks',
    'lot2_Foundations',
    'lot3_ElectricalNetwork',
    'lot4_PdlPtr',
    'lot5_WindTurbines',
    'lot6_Supervision',
    'lot7_Ess',
    'lot8_Modules',
    'lot9_Decommissioning',
    'lot10_Transport',
    'misc',
    'uncertainties'
  ];

  constructor(options?: Partial<ScenarioCapexExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public static fromDto(dto: ScenarioCapex): ScenarioCapexExt {
    return new ScenarioCapexExt(Object.fromEntries(
      this.fieldList
        // eslint-disable-next-line
        .filter(k => dto.hasOwnProperty(k as keyof ScenarioCapex))
        .map((k) => {
          switch (k) {
            case 'spvPurchaseDate':{
              const value = dto[k as keyof ScenarioCapex] ? localeDateFromUTC(dto[k as keyof ScenarioCapex] as string) : '';
              return [k, value];
            }
            default:
              return [k, dto[k as keyof ScenarioCapex]];
          }
        })
    ));
  }

  public toDto(): ScenarioCapex {
    return new ScenarioCapex(Object.fromEntries(
      ScenarioCapexExt.fieldList
        // eslint-disable-next-line
        .filter(k => this.hasOwnProperty(k as keyof ScenarioCapexExt))
        .map((k) => {
          switch (k) {
            case 'spvPurchaseDate':{
              const value = this[k as keyof ScenarioCapex] ? localeDateToUTC(new Date(this[k as keyof ScenarioCapex] as string)) : '';
              return [k, value];
            }
            default:
              return [k, this[k as keyof ScenarioCapex]];
          }
        })
    ));
  }
}
